module.exports = __webpack_public_path__ + "img/villages.65247595.svg";